export default __webpack_public_path__ + "static/media/5042.b4ed3f3c.png";